export default __webpack_public_path__ + "static/media/04_Stepanavan_Lakes.6199091c.webp";